export const ServiceConfigFieldMapping = {
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  TECHINICIAN: 'technician',
  TEST_TYPE: 'testType',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SCHEDULER: 'scheduler',
  SLECTED_APP: 'selectedApp',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  SELECTED_APP_ID: 'selectedAppId',
  INTERVAL: 'interval',
  PROXY_CONFIG: 'proxyConfig',
  THRESHOLD_CRITICALL: 'thresholdCritical',
  THRESHOLD_WARNING: 'thresholdWarning'
};

export const SERVICE_AGENT_MODEL_CONFIG = {
  id: 'service_test',
  agentConfig: {
    default: {
      setup: {
        alias: {
          enabled: true,
          value: 'Service',
          outputField: ServiceConfigFieldMapping.ALIAS,
          tabId: 'service_setup'
        },
        customer: {
          enabled: true,
          value: '',
          outputField: ServiceConfigFieldMapping.CUSTOMER,
          tabId: 'service_setup',
          outputOptional: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: ServiceConfigFieldMapping.TECHINICIAN,
          tabId: 'service_setup',
          outputOptional: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: ServiceConfigFieldMapping.RUN_TYPE,
          tabId: 'service_setup'
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: ServiceConfigFieldMapping.AGENT_TYPE,
          tabId: 'service_setup'
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: 'now', isValid: true },
          outputField: ServiceConfigFieldMapping.SCHEDULER,
          tabId: 'service_setup'
        },
        interval: {
          enabled: true,
          value: 60,
          outputField: ServiceConfigFieldMapping.INTERVAL,
          tabId: 'service_setup'
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: ServiceConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'service_setup'
        },
        selectedApp: {
          enabled: true,
          value: null,
          outputField: ServiceConfigFieldMapping.SLECTED_APP,
          tabId: 'service_setup'
        },
        selectedAppId: {
          enabled: true,
          value: null,
          outputField: ServiceConfigFieldMapping.SELECTED_APP_ID,
          tabId: 'service_setup',
          outputOptional: true
        },
        criticalThreshold: {
          enabled: true,
          value: 90,
          outputField: ServiceConfigFieldMapping.THRESHOLD_CRITICALL,
          tabId: 'service_setup'
        },
        warningThreshold: {
          enabled: true,
          value: 98,
          outputField: ServiceConfigFieldMapping.THRESHOLD_WARNING,
          tabId: 'service_setup'
        },
        proxyConfig: {
          enabled: true,
          value: [
            {
              key: 'web-proxy',
              value: '{"config":{"useDefault":true,"protocol":null,"address":null,"port":null}}'
            }
          ],
          outputField: ServiceConfigFieldMapping.PROXY_CONFIG,
          tabId: 'service_advanced',
          outputOptional: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      }
    }
  }
};
